import { isArray, isEmpty, startCase } from 'lodash';
import moment from 'moment';
import React from 'react';

const splitRange = (range: string) => {
  return range.replace(/([[\] ])/gm, '').split(',');
};

export const formatUTCTimeToLocal = (
  utcTime?: string,
  format = 'YYYY-MM-DD HH:mm'
) => {
  if (utcTime) {
    try {
      return moment
        .utc(utcTime)
        .local()
        .format(format);
    } catch (error) {
      return 'Invalid Date';
    }
  } else {
    return undefined;
  }
};

export const formatLocalTimeToUTC = (localTime?: string) => {
  if (localTime) {
    return moment(localTime)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  } else {
    return undefined;
  }
};

export const formatRevenueRange = (
  range: string | null,
  priceCurrency: string
) => {
  if (!range) {
    return '';
  }
  const [lower, upper] = splitRange(range);
  if (lower === '') {
    return `Less than ${upper} million ${priceCurrency}`;
  }
  if (upper === '') {
    return `More than ${lower} million ${priceCurrency}`;
  }
  return `${lower} - ${upper} million ${priceCurrency}`;
};

export const formatEmployeeRange = (range: string | null) => {
  if (!range) {
    return '';
  }
  const [lower, upper] = splitRange(range);
  if (lower === '') {
    return `Less than ${upper} People`;
  }
  if (upper === '') {
    return `More than ${lower} People`;
  }
  return `${lower} - ${upper} People`;
};

export const formatPrice = (price?: number) => {
  return price != null ? Number(price.toFixed(2)) : undefined;
};

export const format2dp = (value?: number | string | null): string => {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  return Number.isNaN(n) ? String(value) : n.toFixed(2);
};

export const formatPriceNumber = (price?: number, currency?: string) => {
  if (!price || isNaN(price)) {
    return '-';
  }

  const str = Number(price.toFixed(2)).toLocaleString();

  return `${str}${!!currency ? ` ${currency}` : ''}`;
};

export const renderObject = (payload: object) => {
  if (isEmpty(payload)) {
    return null;
  }
  if (isArray(payload)) {
    return (
      <ul>
        {payload.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
    );
  }
  return (
    <ul>
      {Object.entries(payload).map(([key, value]) => (
        <li key={key}>
          {startCase(key)}: <b>{String(value)}</b>
        </li>
      ))}
    </ul>
  );
};

export const getCurrencyFromRegion = (region: string) => {
  switch (region) {
    case 'SG':
      return 'SGD';
    case 'VN':
      return 'VND';
    case 'TH':
      return 'THB';
    case 'IN':
      return 'INR';
    case 'CN':
      return 'CNY';
    case 'AU':
      return 'AUD';
    case 'MY':
      return 'MYR';
    case 'ID':
      return 'IDR';
    case 'PH':
      return 'PHP';
    case 'HK':
      return 'HKD';
    case 'TW':
      return 'TWD';
    case 'KR':
      return 'KRW';
    case 'JP':
      return 'JPY';
    case 'NZ':
      return 'NZD';
    case 'BD':
      return 'BDT';
    case 'PK':
      return 'PKR';
    case 'LK':
      return 'LKR';
    case 'KH':
      return 'KHR';
    case 'LA':
      return 'LAK';
    case 'MM':
      return 'MMK';
    case 'BN':
      return 'BND';
    case 'TL':
      return 'USD';
    case 'US':
      return 'USD';
    case 'GB':
      return 'GBP';
    case 'EU':
      return 'EUR';
    case 'CA':
      return 'CAD';
    case 'NP':
      return 'NPR';
    default:
      return '';
  }
};
